/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Form from "./Components/OrdenForm";
import { request } from "../../utils/request";
import PageHeader from "../general/PageHeader";

const EditOrden = () => {
	const { id } = useParams();
	const [orden, setOrden] = useState({});

	const getOrden = () => {
		request("ordenes-compra/" + id).then((res) => {
			setOrden(res.data);
		});
	};

	useEffect(() => {
		getOrden();
	}, []);

	return (
		<>
			<PageHeader title="Editar Orden de Compra" hasButton={false} />
			<Form ordenActual={orden} isEdit={true} />
		</>
	);
};

export default EditOrden;
